export default function preventScrolling() {
	const doc = document.documentElement
	const scrollBarSize = getScrollBarSize()

	let isOn = false
	let scrollTop

	function on(options) {
		if (typeof document === 'undefined' || isOn) {
			return
		}

		scrollTop = window.pageYOffset
		if (hasScrollbar()) {
			doc.style.width = `calc(100% - ${scrollBarSize}px)`
		} else {
			doc.style.width = '100%'
		}

		doc.style.position = 'fixed'
		doc.style.top = `-${scrollTop}px`
		doc.style.overflow = 'hidden'
		isOn = true
	}

	function off() {
		if (typeof document === 'undefined' || !isOn) {
			return
		}
		resetStyles()
		window.scroll(0, scrollTop)
		isOn = false
	}

	function toggle() {
		if (isOn) {
			off()
			return
		}
		on()
	}

	return {
		on,
		off,
		toggle
	}
}

function getScrollBarSize() {
	const doc = document.documentElement
	const scroller = document.createElement('div')
	scroller.setAttribute('style', 'style', 'width:99px;height:99px;position:absolute;top:-9999px;overflow:scroll;')
	doc.appendChild(scroller)
	const scrollBarSize = scroller.offsetWidth - scroller.clientWidth
	doc.removeChild(scroller)
	return scrollBarSize
}

function hasScrollbar() {
	return document.documentElement.scrollHeight > window.innerHeight
}

function resetStyles() {
	const doc = document.documentElement
	doc.style.width = ''
	doc.style.position = ''
	doc.style.top = ''
	doc.style.overflow = ''
}
